export const isMobileViewport = () => {
  try {
    return window.innerWidth <= 767.98;
  } catch (_error) {
    return false;
  }
};
